import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainComponent } from './common/main/main.component';
import { MasterRoutes } from './core/constants/route.constant';

const routes: Routes = [
  {
    path: '',
    component: MainComponent,
    children: [
      {
        path: MasterRoutes.Events,
        loadChildren: () =>
          import('./modules/events/events.module').then(
            (m) => m.EventsModule
          ),
      },
    ],
  },
  {
    path: '',
    component: MainComponent,
  },
  {
    path: MasterRoutes.Okta,
    loadChildren: () => import('./modules/okta/okta.module').then(m => m.OktaModule)
  },

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      onSameUrlNavigation: 'reload',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }


